import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Summer/Decimals/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Decimals',
  field: 'Number',
  weeks: [6, 8],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Decimals/1UseKnownFactsToAddAndSubtractDecimalsWithin1" */ './1UseKnownFactsToAddAndSubtractDecimalsWithin1'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year5/Summer/Decimals/2ComplementsTo1" */ './2ComplementsTo1')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Decimals/3AddAndSubtractDecimalsAcross1" */ './3AddAndSubtractDecimalsAcross1'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Decimals/4AddDecimalsWithTheSameNumberOfDecimalPlaces" */ './4AddDecimalsWithTheSameNumberOfDecimalPlaces'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Decimals/5SubtractDecimalsWithTheSameNumberOfDecimalPlaces" */ './5SubtractDecimalsWithTheSameNumberOfDecimalPlaces'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Decimals/6AddDecimalsWithDifferentNumbersOfDecimalPlaces" */ './6AddDecimalsWithDifferentNumbersOfDecimalPlaces'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Decimals/7SubtractDecimalsWithDifferentNumbersOfDecimalPlaces" */ './7SubtractDecimalsWithDifferentNumbersOfDecimalPlaces'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Decimals/8EfficientStrategiesForAddingAndSubtractingDecimals" */ './8EfficientStrategiesForAddingAndSubtractingDecimals'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Decimals/9DecimalSequences" */ './9DecimalSequences'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Decimals/10MultiplyBy10100And1000" */ './10MultiplyBy10100And1000'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Decimals/11DivideBy10100And1000" */ './11DivideBy10100And1000'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Summer/Decimals/12MultiplyAndDivideDecimalsMissingValues" */ './12MultiplyAndDivideDecimalsMissingValues'
        )
    })
  ]
});
export default Block;
